import React, { forwardRef } from 'react';

const tableContainerStyle = {
    position: 'relative',
    width: '100%',
    overflow: 'auto',
    borderRadius: '0.5rem',
    border: '1px solid #e2e8f0'
};

const tableStyle = {
    width: '100%',
    captionSide: 'bottom',
    fontSize: '0.875rem',
    borderCollapse: 'collapse'
};

const headerStyle = {
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0'
};

const rowStyle = {
    borderBottom: '1px solid #e2e8f0',
    transition: 'background-color 0.2s',
    '&:hover': { backgroundColor: '#f1f5f9' } // Note: inline styles don't support pseudo-classes well without library
};

const headStyle = {
    height: '3rem',
    padding: '0 1rem',
    textAlign: 'left',
    verticalAlign: 'middle',
    fontWeight: '500',
    color: '#64748b' // slate-500
};

const cellStyle = {
    padding: '1rem',
    verticalAlign: 'middle'
};

const captionStyle = {
    marginTop: '1rem',
    fontSize: '0.875rem',
    color: '#64748b'
};

const Table = forwardRef(({ className, style, ...props }, ref) => (
    <div style={tableContainerStyle}>
        <table
            ref={ref}
            style={{ ...tableStyle, ...style }}
            {...props}
        />
    </div>
));
Table.displayName = "Table";

const TableHeader = forwardRef(({ className, style, ...props }, ref) => (
    <thead ref={ref} style={{ ...headerStyle, ...style }} {...props} />
));
TableHeader.displayName = "TableHeader";

const TableBody = forwardRef(({ className, style, ...props }, ref) => (
    <tbody
        ref={ref}
        style={{ ...style }}
        {...props}
    />
));
TableBody.displayName = "TableBody";

const TableFooter = forwardRef(({ className, style, ...props }, ref) => (
    <tfoot
        ref={ref}
        style={{ borderTop: '1px solid #e2e8f0', backgroundColor: '#f8fafc', fontWeight: '500', ...style }}
        {...props}
    />
));
TableFooter.displayName = "TableFooter";

const TableRow = forwardRef(({ className, style, ...props }, ref) => (
    <tr
        ref={ref}
        style={{ ...rowStyle, ...style }}
        {...props}
    />
));
TableRow.displayName = "TableRow";

const TableHead = forwardRef(({ className, style, ...props }, ref) => (
    <th
        ref={ref}
        style={{ ...headStyle, ...style }}
        {...props}
    />
));
TableHead.displayName = "TableHead";

const TableCell = forwardRef(({ className, style, ...props }, ref) => (
    <td
        ref={ref}
        style={{ ...cellStyle, ...style }}
        {...props}
    />
));
TableCell.displayName = "TableCell";

const TableCaption = forwardRef(({ className, style, ...props }, ref) => (
    <caption
        ref={ref}
        style={{ ...captionStyle, ...style }}
        {...props}
    />
));
TableCaption.displayName = "TableCaption";

export {
    Table,
    TableHeader,
    TableBody,
    TableFooter,
    TableHead,
    TableRow,
    TableCell,
    TableCaption,
};
